import actionTypes from '../actions/action-types';

const initialState = {
  current: {},
  toSave: {},
  copy: {},
  layouts: [],
  isEditMode: false,
  widgets: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DASHBOARD_REQUEST:
    case actionTypes.FETCH_DASHBOARD_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case actionTypes.FETCH_DASHBOARD_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        current: action.current || {},
        toSave: action.toSave || {},
      };
    case actionTypes.SET_DASHBOARD_CURRENT:
      return {
        ...state,
        isLoading: action.isLoading,
        current: action.current || {},
      };
    case actionTypes.SET_DASHBOARD_LAYOUTS:
      return {
        ...state,
        layouts: action.layouts || [],
      };
    case actionTypes.SET_DASHBOARD_EDIT_MODE:
      return {
        ...state,
        isEditMode: action.isEditMode || false,
      };
    case actionTypes.SET_DASHBOARD_COPY:
      return {
        ...state,
        copy: action.copy || {},
      };
    case actionTypes.SET_DASHBOARD_WIDGETS_LIST:
      return {
        ...state,
        widgets: action.widgets || [],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/dashboard.reducer.js